import { render, staticRenderFns } from "./ProdukEdit.vue?vue&type=template&id=5cf9716d&scoped=true"
import script from "./ProdukEdit.vue?vue&type=script&lang=js"
export * from "./ProdukEdit.vue?vue&type=script&lang=js"
import style0 from "./ProdukEdit.vue?vue&type=style&index=0&id=5cf9716d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf9716d",
  null
  
)

export default component.exports